var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader",staticStyle:{"text-align":"center"},style:({'font-size': (_vm.fontSize + "px"),
     'margin-top': ((_vm.fontSize * 2) + "px"),
     'margin-bottom': ((_vm.fontSize * 2) + "px"),})},[_c('i',{staticClass:"el-icon-loading"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ff3c0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader/index.vue
// module id = null
// module chunks = 